import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get("v1/comment", {
        params,
      });

      if (!response.data) {
        return [];
      }
      
      commit("setData", response.data.data);
      return response.data;
    },
    async add(_, params) {
      const { data } = await axios.post("v1/comment", params);
      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/comment/${id}`);
      return data;
    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
